import moment from 'moment'

export const customerComplaintUser = {
    id: '',
    customerComplaintId: '',
    complaintNo: '',
    question: '',
    answer: '',
    attachment: '',
    createdBy: '',
    updatedBy: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}